<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加链接路径</el-button
    >

    <el-dialog
      title="添加app链接路径"
      width="800px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="线路zh" prop="zh">
          <el-input
            v-model.trim="ruleForm.zh"
            placeholder="请输入线路名称(中文) 例如 线路1"
          ></el-input>
        </el-form-item>
        <el-form-item label="线路en" prop="en">
          <el-input
            v-model.trim="ruleForm.en"
            placeholder="请输入线路名称(英文) 例如 line1"
          ></el-input>
        </el-form-item>
        <el-form-item label="线路名称" prop="lineUrl">
          <el-input
            v-model.trim="ruleForm.lineUrl"
            placeholder="请输入域名或地址 如 https://www.baidu.com"
          ></el-input>
        </el-form-item>
        <el-form-item label="测速类型">
          <el-select v-model="speedTestType" style="width: 220px">
            <el-option
              v-for="item in speedTestOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            style="margin-left: 8px"
            :loading="speedTesting"
            :disabled="!ruleForm.lineUrl"
            @click="handleSpeedTest"
            >测速</el-button
          >
        </el-form-item>
        <el-form-item v-if="speedResult" label="测速结果">
          <span :style="{ color: speedResult.ok ? '#67c23a' : '#f56c6c' }">
            {{
              speedResult.ok
                ? `成功 ${speedResult.ms}ms（HTTP ${speedResult.status}）`
                : `失败：${speedResult.error}`
            }}
          </span>
        </el-form-item>
        <el-form-item label="租户选择" prop="tenantId">
          <el-select
            v-model="ruleForm.tenantId"
            placeholder="租户选择"
            clearable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="国家区号" prop="code">
          <el-input
            v-model.trim="ruleForm.code"
            placeholder="请输入国家区号，例如中国为86"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家码" prop="locale">
          <el-input
            v-model.trim="ruleForm.locale"
            placeholder="例如中国为CHN"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="启用状态" prop="status">
          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为启用，红色则为未启用"
            placement="right"
          >
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定添加</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  ValidateCode,
  ValidateEN,
  ValidateLocale,
  ValidateZH,
  ValidateLineUrl,
} from "../../validate.js";
import { tenantInfo } from "@/common/publicApi";
import {
  SPEED_TEST_OPTIONS,
  buildSpeedTestUrl,
  runSpeedTest,
} from "../../speedTest";
export default {
  data() {
    return {
      dialogVisible: false,
      speedTestType: "inspectsurvival",
      speedTestOptions: SPEED_TEST_OPTIONS,
      speedTesting: false,
      speedResult: null,
      ruleForm: {
        zh: "",
        // locale: "",
        // code: "",
        en: "",
        lineUrl: "",
        tenantId: "",
        status: false,
      },
      arr: [],
      result: false,
      rules: {
        zh: [
          {
            required: true,
            message: "请输入线路名称（zh）",
            trigger: "blur",
          },
          // { message: "请输入线路名称", trigger: "blur" },
        ],
        en: [
          { required: true, message: "请输入线路名称（en）", trigger: "blur" },
          //  { message: "不能为空", trigger: "blur" },
        ],

        lineUrl: [
          {
            required: true,
            validator: ValidateLineUrl,
            trigger: "blur",
          },
        ],
      },
      tenantList: [],
    };
  },
  mounted() {
    // this.ruleForm = {
    //   zh: "",
    //   lineUrl:'',
    //   en: "",
    //   status: 0,
    // };
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
  },
  methods: {
    ...mapActions("appLineUrl", ["addOne", "getlist", "getUrlList"]),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    resetSpeedTestState() {
      this.speedTestType = "inspectsurvival";
      this.speedTesting = false;
      this.speedResult = null;
    },
    async handleSpeedTest() {
      if (!this.ruleForm.lineUrl) {
        this.$message.warning("请先填写线路地址");
        return;
      }
      this.speedTesting = true;
      this.speedResult = null;
      const url = buildSpeedTestUrl(this.ruleForm.lineUrl, this.speedTestType);
      const result = await runSpeedTest(url);
      this.speedResult = result;
      this.speedTesting = false;
      if (result.ok) {
        this.$message.success(`测速成功：${result.ms}ms`);
      } else {
        this.$message.error(result.error || "测速失败");
      }
    },
    closeDialog() {
      this.resetForm("ruleForm");
      this.resetSpeedTestState();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        // console.log('this.ruleForm',this.ruleForm);
        if (valid) {
          const obj = {
            ...this.ruleForm,
            status: this.ruleForm.status,
          };
          // this.$refs[formName].validate(async (val) => {
          const res = await this.addOne(obj);
          if (res.code == 0) {
            this.dialogVisible = false;
            this.getUrlList({ page: 1, size: 10, lineUrl: "" });
            this.ruleForm = {
              zh: "",
              en: "",
              lineUrl: "",
              tenantId: "",
              status: false,
            };
            this.resetSpeedTestState();
            this.$message.success("添加成功");
          } else {
            this.$message.console.error("添加失败，请重试");
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.resetSpeedTestState();
    },
  },
};
</script>

<style lang="less" scoped></style>
